import { View, Card, Tabs } from '@acin/ui-core';
import styled from 'styled-components';

export const MapControls = styled(View)`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
`;

export const Columns = styled(View)`
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.theme.spacing.getSize(4)};
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const LeftColumn = styled(Card)`
  display: flex;
  flex-direction: row;
  width: 365px;
  min-width: 365px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 0;
`;

export const LeftSubColumn = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  border-right: 1px solid ${(p) => p.theme.colors.borders.getValue(3)};

  &:last-child {
    border-right: none;
  }
`;

export const LeftSubColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: auto;
  box-sizing: border-box;
`;

export const ColumnHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: ${(p) => p.theme.spacing.getSize(4)};
  border-bottom: 1px solid ${(p) => p.theme.colors.borders.getValue(3)};
  box-sizing: border-box;
  flex-shrink: 0;
`;

export const RightColumns = styled(Card)`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 0;
`;

export const RightSubColumn = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  border-right: 1px solid ${(p) => p.theme.colors.borders.getValue(3)};

  &:last-child {
    border-right: none;
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: ${(p) => p.theme.spacing.getSize(4)};
  overflow: auto;
  box-sizing: border-box;
`;

export const PlaceholderText = styled.div`
  color: ${(p) => p.theme.colors.text.getValue(2)};
  font-size: ${(p) => p.theme.type.getSize()};
`;

export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(p) => p.theme.spacing.getSize(4)};
  border-top: 1px solid ${(p) => p.theme.colors.borders.getValue(3)};
  box-sizing: border-box;
  flex-shrink: 0;
`;

export const Sentinel = styled.div`
  height: 1px;
  width: 100%;
`;

export const StyledTabs = styled(Tabs)`
  margin: ${(p) => p.theme.spacing.getSize(4)};
`;
